import React, { Component } from 'react';
import Modal from 'react-modal';
import '../App.css';

/*
The app element allows you to specify the portion of your app that should be hidden (via aria-hidden)
to prevent assistive technologies such as screenreaders from reading content outside of the content of
your modal.  It can be specified in the following ways:

* element
Modal.setAppElement(appElement);

* query selector - uses the first element found if you pass in a class.
Modal.setAppElement('#your-app-element');


const appElement = document.getElementById('your-app-element');*/



const customStyles = {
  content : {
  }
};


class ActionForm extends Component {
  constructor() {
    super();

    this.state = {
      modalIsOpen: false
    };

    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({modalIsOpen: true});
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  closeModal() {
    this.setState({modalIsOpen: false});
  }

  render() {
    return (
      <div>
        <button className="button action" onClick={this.openModal}>
          Click here to discuss your results further with us including the best ways to protect and exploit your brand
        </button>
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          style={customStyles}
          shouldCloseOnOverlayClick={false}
          className="Modal"
          overlayClassName="Overlay"
          contentLabel="Contact Form"
        >

          <div className="resultBox__title">Contact form
            <span className='close_modal' onClick={this.closeModal}>&times;</span>
          </div>
          <form id='contactForm' className="modalForm" action="https://formspree.io/info@brandsmiths.co.uk"
      method="POST">
            <input type="hidden" name="_cc" value="andy@brandsmiths.co.uk"/>
            <span>Please fill your contact information below.<br/> Fields marked with * are required.</span><br/>
            <br/>
            Name:* <input type="text" name="name" required/><br/>
            E-mail:* <input type="email" name="email" required/><br/>
            Contact number: <input type="tel" name="phone"/><br/>
            <input type="hidden" name="search-query" value={this.props.query}/>
            Additional information: <input type="text" name="information"/><br/>
            <input className="button form" type="submit" value="Send"/>
          </form>
        </Modal>
      </div>
    );
  }
}
export default ActionForm;



// WEBPACK FOOTER //
// ./client/src/Engines/Actionform.js